import React, { useState } from "react"
import { Link } from "gatsby"
import { Container } from "react-bootstrap"
import { GatsbyImage } from "gatsby-plugin-image"

import {
	Box,
	ImageList,
	ImageListItem,
    ImageListItemBar,
} from "@mui/material"

import * as styles from "./Gallery.module.scss"
import ImagePreview from "../ImagePreview/ImagePreview"

import typeMapping from "../../data/type_mapping.json"
import useImageData from "../../hooks/useImageData"
import useMapData from "../../hooks/useMapData"

import IconButton from '@mui/material/IconButton';
import SquareIcon from '@mui/icons-material/Square';

const Gallery = () => {
	const legendsCode = Object.keys(typeMapping)
	const legends = legendsCode.map(key => ({ key, ...typeMapping[key] }))
    const [filterType, setFilterType] = useState(Object.fromEntries(legendsCode.map(loc => [loc, true])))
    const imageData = useImageData()
	const placesData = useMapData().filter(place => Object.keys(imageData).some(id => id === place.id.toString()))
    
    function handleFilterType(type) {
		setFilterType({ ...filterType, [type]: !filterType[type] })
	}

    function allPlacesData() {
        return placesData
               .filter(place => filterType[place.type])
    }

    // ImagePreview states
    const [open, setOpen] = React.useState(false);
	const [previewImage, setPreviewImage] = useState();
	const handleOpen = (img) => {
		setPreviewImage(img);
		setOpen(true);
	}
	const handleClose = () => setOpen(false);

    return (
        <Container>
            <h1>Gallery</h1>

            <Box
                className={styles.legends}
            >
                {legends.map(legend => 
                    <span
                        role="button"
                        tabIndex="0"
                        key={legend.name}
                        style={{ cursor: "pointer", outline: "none", opacity: filterType[legend.key] ? 1 : 0.3 }}
                        onClick={() => handleFilterType(legend.key)}
                        onKeyPress={() => {}}
                    >
                        <span className={styles.colorBox} style={{backgroundColor: legend.color}}>
                        </span>
                        {legend.name}
                    </span>
                )}
            </Box>
            
            <Box sx={{ height: '65vh', overflowY: 'scroll' }}>
                <ImageList variant="masonry" cols={3} gap={8}>
                    {allPlacesData().map(place => {
                        const { id, english_name_I, full_address, type } = place
                        const curr_color = legends.find(legend => legend.key === type).color
                        const curr_img = imageData[id]
                        return (
                            <ImageListItem key="{id}">
                                <GatsbyImage
                                    onClick={ () => handleOpen(curr_img) }
                                    image={curr_img}
                                    alt={english_name_I}
                                    loading="lazy"
                                />
                                <Link
                                    to="/map"
                                    state={{id}}
                                >
                                    <ImageListItemBar
                                        title={english_name_I}
                                        subtitle={full_address}
                                        actionIcon={
                                            <IconButton sx={{ color: curr_color }}>
                                                <SquareIcon></SquareIcon>
                                            </IconButton>
                                          }
                                    />
                                </Link>
                            </ImageListItem>
                        )
                    })}
                </ImageList>
            </Box>
            <ImagePreview
                open={open}
                image={previewImage}
                handleClose={handleClose}
            />
        </Container>
	)
}

export default Gallery
